import axios from '../../plugins/axios-silent';

export default {
  namespaced: true,

  state: {
    customerLoyalty: null,
    loyaltyLoaded: false,
    loyaltyError: null,
    modalOpening: false
  },

  mutations: {
    SET_CUSTOMER_LOYALTY(state, payload) {
      state.customerLoyalty = payload;
    },
    SET_LOYALTY_LOADED(state, payload) {
      state.loyaltyLoaded = payload;
    },
    SET_LOYALTY_ERROR(state, payload) {
      state.loyaltyError = payload;
    },
    CLEAR_CUSTOMER_LOYALTY(state) {
      state.customerLoyalty = null;
    },
    SET_MODAL_OPENING(state, payload) {
      state.modalOpening = payload;
    }
  },

  actions: {
    async checkLoyalty({ commit }) {
      try {
        commit('SET_LOYALTY_LOADED', false);
        commit('SET_LOYALTY_ERROR', null);
        
        const { data } = await axios.get('/front/customer-loyalty/check');
        console.log(data, 'datadatadatadatadatadatadata');
        
        commit('SET_CUSTOMER_LOYALTY', data.loyalty);
        commit('SET_LOYALTY_LOADED', true);
        
        return data;
      } catch (error) {
        commit('SET_LOYALTY_ERROR', error.response?.data?.message || 'Ошибка при проверке статуса программы лояльности');
        commit('SET_LOYALTY_LOADED', true);
        return { exists: false, loyalty: null };
      }
    },

    async acceptTerms({ commit }) {
      try {
        commit('SET_LOYALTY_LOADED', false);
        commit('SET_LOYALTY_ERROR', null);
        
        const { data } = await axios.post('/front/customer-loyalty/accept-terms', {
          provider_type: 'vkusvil'
        });
        
        commit('SET_CUSTOMER_LOYALTY', data);
        commit('SET_LOYALTY_LOADED', true);
        
        return data;
      } catch (error) {
        commit('SET_LOYALTY_ERROR', error.response?.data?.message || 'Ошибка при принятии условий программы лояльности');
        commit('SET_LOYALTY_LOADED', true);
        throw error;
      }
    },

    async declineTerms({ commit }) {
      try {
        commit('SET_LOYALTY_LOADED', false);
        commit('SET_LOYALTY_ERROR', null);
        
        const { data } = await axios.post('/front/customer-loyalty/decline-terms', {
          provider_type: 'vkusvil'
        });
        
        commit('SET_CUSTOMER_LOYALTY', data);
        commit('SET_LOYALTY_LOADED', true);
        
        return data;
      } catch (error) {
        commit('SET_LOYALTY_ERROR', error.response?.data?.message || 'Ошибка при отказе от программы лояльности');
        commit('SET_LOYALTY_LOADED', true);
        throw error;
      }
    },

    async getCurrentLoyalty({ commit }) {
      try {
        commit('SET_LOYALTY_LOADED', false);
        commit('SET_LOYALTY_ERROR', null);
        
        const { data } = await axios.get('/front/customer-loyalty/current');
        commit('SET_CUSTOMER_LOYALTY', data);
        commit('SET_LOYALTY_LOADED', true);
        
        return data;
      } catch (error) {
        if (error.response?.status !== 404) {
          commit('SET_LOYALTY_ERROR', error.response?.data?.message || 'Ошибка при получении программы лояльности');
        }
        commit('SET_LOYALTY_LOADED', true);
        return null;
      }
    },

    clearLoyalty({ commit }) {
      commit('CLEAR_CUSTOMER_LOYALTY');
    },

    setModalOpening({ commit }, isOpening) {
      commit('SET_MODAL_OPENING', isOpening);
      
      // Автоматически сбрасываем флаг через 500ms
      if (isOpening) {
        setTimeout(() => {
          commit('SET_MODAL_OPENING', false);
        }, 500);
      }
    }
  }
};